import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Accessibility, HighlightOff } from '@mui/icons-material';
import { blue, red } from '@mui/material/colors';
import { Position } from '../types';

const positions = [
  {
    short: Position.GK,
    full: 'Goalkeeper',
  },
  {
    short: Position.CB,
    full: 'Central back',
  },
  {
    short: Position.LB,
    full: 'Left back',
  },
  {
    short: Position.RB,
    full: 'Right back',
  },
  {
    short: Position.CM,
    full: 'Central midfielder',
  },
  {
    short: Position.LW,
    full: 'Left winger',
  },
  {
    short: Position.RW,
    full: 'Right winger',
  },
  {
    short: Position.DM,
    full: 'Defensive midfielder',
  },
  {
    short: Position.AM,
    full: 'Attacking midfielder',
  },
  {
    short: Position.LF,
    full: 'Left forward',
  },
  {
    short: Position.ST,
    full: 'Striker',
  },
  {
    short: Position.RF,
    full: 'Right forward',
  },
];

type PositionDialogProps = {
  open: boolean;
  onClose: (position?: Position) => void;
};

export default function PositionDialog({
  open,
  onClose,
}: Readonly<PositionDialogProps>) {
  const handleClose = () => {
    onClose(undefined);
  };

  const handleListItemClick = (value?: Position) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Set player position</DialogTitle>
      <List sx={{ pt: 0 }}>
        <ListItem button onClick={() => handleListItemClick()}>
          <ListItemAvatar>
            <Avatar sx={{ bgcolor: red[100], color: red[600] }}>
              <HighlightOff />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Reset position" />
        </ListItem>
        {positions.map(({ short, full }) => (
          <ListItem
            button
            onClick={() => handleListItemClick(short)}
            key={short}
          >
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                <Accessibility />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={`${short} - ${full}`} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}
